module.exports = __WEBPACK_EXTERNAL_MODULE__reactodia_worker_proxy_protocol_0beb1c9e__;